import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { OfferStyleSlider } from "./components/OfferStyleSlider";

interface AppearanceSectionProps {
  cornerRadius: number;
  spacing?: string;
  onCornerRadiusChange: (value: number) => void;
  onSpacingChange?: (value: number) => void;
  disabled?: boolean;
}

export const AppearanceSection = ({
  cornerRadius,
  spacing,
  onCornerRadiusChange,
  onSpacingChange,
  disabled,
}: AppearanceSectionProps) => {
  return (
    <Grid item container direction="column" rowSpacing={3}>
      <Grid item>
        <IgTypography fontWeight="600" variant={"body1"}>
          Appearance
        </IgTypography>
      </Grid>
      <Grid item container columnSpacing={8}>
        <OfferStyleSlider
          disabled={disabled}
          label="Corner radius"
          value={cornerRadius}
          onChange={onCornerRadiusChange}
          min={0}
          max={20}
          xs={4}
        />
        {spacing && onSpacingChange && (
          <OfferStyleSlider
            disabled={disabled}
            label="Spacing"
            value={parseInt(spacing) || 0}
            onChange={onSpacingChange}
            min={0}
            max={40}
            xs={4}
          />
        )}
      </Grid>
    </Grid>
  );
};
